import {
  FormControl,
  FormHelperText,
  MenuItem,
  Select,
} from '@material-ui/core'
import { useController } from 'react-hook-form'
import { useFieldStyles } from './Field.style'
import { FieldProps } from './interfaces'

type SelectFieldProps = {
  options: { label: string; value: string | number }[];
   // eslint-disable-next-line
  control: any;
  name: string
} & FieldProps

export const SelectField = (props: SelectFieldProps) => {
  const { label, name, control, defaultValue, options, rules, disabled } = props
  const style = useFieldStyles()

  const {
    field,
    fieldState: { error },
  } = useController({ control, name, defaultValue, rules })

  return (
    <FormControl className={`${style.fieldBox}`} error={!!error?.message}>
      {label && (
        <label className={style.fieldLabel} title={label}>
          {label}
        </label>
      )}
      <Select
        {...field}
        style={{
          marginTop: 0,
        }}
        disabled={disabled}
      >
        {options.map(({ label, value }) => (
          <MenuItem key={value} value={value}>
            {label}
          </MenuItem>
        ))}
      </Select>
      <FormHelperText className={style.fieldErrorMessage}>
        {error?.message || ' '}
      </FormHelperText>
    </FormControl>
  )
}
